import { PlatformSlug } from 'constants/consts'
import { enabledOn, isFeatureAvailable } from 'platformConfig'

export const ACHIEVEMENTS_CONFIG = enabledOn(
  PlatformSlug.DATBooster,
  PlatformSlug.OATBooster,
  PlatformSlug.DATCrusher,
  PlatformSlug.PATBooster,
  PlatformSlug.INBDEBooster,
  PlatformSlug.CasperBooster,
  PlatformSlug.NBDHEBooster,
  PlatformSlug.NDEBCrusher,
  PlatformSlug.CARSBooster,
  PlatformSlug.GREBooster
)

export const isAchievementsAvailable = (slug?: PlatformSlug) => isFeatureAvailable(ACHIEVEMENTS_CONFIG, slug)
